export function getShopCreditAlertClass(creditAlert) {
  if (creditAlert === "red") {
    return " credit-alert-red";
  }

  if (creditAlert === "yellow") {
    return " credit-alert-yellow";
  }

  return "";
}
